import React from "react";
import { Modal } from "antd";
import locale from "../../locale";
import remindImg from "../../assets/remind.png";

import "./index.less";

const CommonModal = (props: any) => {
  const {
    okText = locale("common_ok"),
    cancelText = locale("common_cancel"),
    modalTile,
    modalVisible,
    setOKModal,
    setonCancelModal,
    okButtonProps,
    cancelButtonProps,
    confirmLoading = false,
    closable = true,
    footer,
    titleIcon,
    noTitleIcon,
    className,
    maskClosable,
    getContainer,
    mask,
    customCloseBtn,
    customCloseHandle,
    width = 416,
    bodyStyle,
    zIndex,
  } = props;
  const titleDom = (
    <span className={"sscard_titleTips"}>
      {!noTitleIcon && <img className={"sscard_title_icon"} src={remindImg} />}
      <span>{modalTile}</span>
      {customCloseBtn && (
        <span
          className={`${"sscard_customClose"} iconfont-yach yach-quanjuqunshezhi-guanbiqunshezhi`}
          onClick={customCloseHandle}
        ></span>
      )}
    </span>
  );
  const closeDom = (
    <span onClick={setonCancelModal}>
      <svg
        width="12px"
        height="12px"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.269333 29.269333a85.333333 85.333333 0 0 0 0 120.661334l844.8 844.8a85.333333 85.333333 0 0 0 120.661334-120.661334l-844.8-844.8a85.333333 85.333333 0 0 0-120.661334 0z"
          fill="#767B82"
        />
        <path
          d="M994.730667 29.269333a85.333333 85.333333 0 0 1 0 120.661334l-844.8 844.8a85.333333 85.333333 0 0 1-120.661334-120.661334l844.8-844.8a85.333333 85.333333 0 0 1 120.661334 0z"
          fill="#767B82"
        />
      </svg>
    </span>
  );
  return (
    <Modal
      okText={okText}
      cancelText={cancelText}
      className={
        className
          ? `${className} sscard_common-modal `
          : modalTile
          ? "sscard_common-modal "
          : `sscard_no_title_body sscard_common-modal `
      }
      title={modalTile ? titleDom : null}
      centered
      visible={modalVisible}
      onOk={setOKModal}
      onCancel={setonCancelModal}
      okButtonProps={okButtonProps}
      cancelButtonProps={cancelButtonProps}
      closable={customCloseBtn ? false : modalTile ? closable : false}
      closeIcon={closable ? closeDom : null}
      confirmLoading={confirmLoading}
      footer={footer}
      mask={mask}
      maskClosable={maskClosable}
      getContainer={getContainer}
      width={width}
      bodyStyle={bodyStyle}
      zIndex={zIndex}
    >
      {props.modalContent}
      {props.children}
    </Modal>
  );
};

export default CommonModal;
